/**
 * @desc 获取多店铺产品列表
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: defs.walmart.AllItemsRequest, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartItems/getProduct`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
